import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/usa1956';

export default function UniformSecuritiesAct() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="The state-law source for the Series 65 — the operative statutory text of the 1956 model act as amended by NASAA, organized by Part and Section."
      parts={parts}
    />
  );
}
